














































import {Vue, Component, Watch, Prop} from 'vue-property-decorator'
import Registration from '@/components/Registration.vue'
import {Action, State} from 'vuex-class'
import {EventBus} from '@/main'
import {DialogState} from '@/store' // @ is an alias to /src
import settings from '@/settings.ts'
import {RegistrationRequest} from '@/store/modules/registration'

@Component({
  name: 'App',
  components: {
    Registration,
  },
})
export default class App extends Vue {
  @State((state) => state.configuration.appConfig.default_language) public defaultLanguage!: string
  @State((state) => state.profile.language) public profileLanguage!: string
  @State((state) => state.registration.client_token) public token!: string
  @State('registration') public registrationState!: RegistrationRequest
  @State('dialogState') public dialogState!: DialogState[]
  @Action('flushEmptyPopups') public flushEmptyPopups: any
  @Action('openDialog') public openDialog: any
  @Action('setLang') public setLang!: any
  @Action('init') public initStore!: any
  @Action('purge') public purgeStore: any


  public loaded: boolean = false
  public dark: boolean = false
  public lang: string = ''
  public langDialog: boolean = false
  public resetDialog: boolean = false

  private changeLang(lang: string) {
    switch (lang) {
      case 'us':
        lang = 'en'
        break
    }
    this.setLang(lang)
    this.$langLoader(lang)
    this.langDialog = false
    this.lang = lang
  }

  private resetData() {
    this.purgeStore()
    this.$router.push({name: 'home'})
    this.resetDialog = false
  }

  private created() {
    EventBus.$on('configLoaded', () => {
      this.loaded = true
      this.lang = this.profileLanguage || this.defaultLanguage
      this.changeLang(this.lang)
    })
    this.initStore()
  }

  private mounted() {
    this.dark = settings.dark || false
    this.flushEmptyPopups()
    if (this.registrationState.address === undefined) {
      // TODO: cobble together a less shitty fallback
      this.purgeStore()
    }
  }

  private get lastDialog() {
    const l = this.dialogState.length - 1
    return this.dialogState.length ? this.dialogState[l] : false
  }

  private get popupIsOpen() {
    const d = this.lastDialog
    let res: string = ''

    if (d) {
      res = 'dialog'
    }

    this.$route.meta.popupIsOpen = !!res

    return res ? res : false
  }

  private get registrationIsClear() {
    return !(
      this.registrationState.name +
      this.registrationState.surname +
      this.registrationState.gender +
      this.registrationState.phone +
      this.registrationState.email +
      this.registrationState.mobile +
      this.registrationState.birthdate
    ).length
  }
}
